import TextBoxSelection from "components/basic/textBoxSelection/textBoxSelectionList";
import TextField from "components/basic/textField";

export interface TextBoxSelectionWithPriceOption {
  label?: string;
  checked: boolean;
  onSelectionChange: (checked: boolean) => void;
  onNameChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  name: string;
  placeHolder?: string;
}

export const TextBoxSelectionWithName: React.FC<
  TextBoxSelectionWithPriceOption
> = ({
  label,
  checked,
  onSelectionChange,
  onNameChange,
  disabled,
  name,
  placeHolder = "Enter Value",
}) => {
  return (
    <div>
      <TextBoxSelection
        label={label}
        checked={checked}
        onChange={onSelectionChange}
        disabled={disabled}
      >
        <TextField
          style={{ marginTop: 8 }}
          placeHolder={placeHolder}
          name={label ?? ""}
          type="text"
          value={name}
          onChange={onNameChange}
        />
      </TextBoxSelection>
    </div>
  );
};
